import {useState} from "react";
import {useSelector} from "react-redux";
import Report from "./report";
import GoalComment from "../goal-comment/goal-comment";
import Project from "../project/project";
import Deliverable from "../deliverable/deliverable";
import Task from "../task/task";
import groupBy from "lodash/groupBy";
import {
    normalizeMembershipEntity,
    prepareMembershipPayload,
} from "../workspace-membership/workspace-membership-identity";

const reportPopulate = {
    workspace: true,
    report_dashboard: true,
    creatorUser: {populate: {member: {populate: {profileImage: true}}}},
    archivedBy: {populate: {member: {populate: {profileImage: true}}}},
};

export function useReport() {
    const [loading, setLoading] = useState(false);
    const {workspaceMembershipData} = useSelector((state) => state.app);
    const memberships = workspaceMembershipData?.workspace?.workspace_memberships || [];

    const goal = new GoalComment();
    const project = new Project();
    const deliverable = new Deliverable();
    const task = new Task();
    const model = {goal, project, deliverable, task};

    const getReports = async (workspaceId, reportDashboardDocumentId)=>{
        if (!workspaceId) return [];
        setLoading(true);
        try {
            const report = new Report();
            const filters = [
                {workspace:{$eq: workspaceId}},
                {
                    $or: [
                        {archivedAt: {$null: true}},
                    ]
                }
            ];
            if (reportDashboardDocumentId) {
                filters.push({report_dashboard: {documentId: {$eq: reportDashboardDocumentId}}});
            }
            const query = {
                filters: {
                    $and: filters,
                },
                populate: reportPopulate,
                sort: ["updatedAt:desc", "createdAt:desc"]
            }
            const _data = await report.getAll(query);

            return (_data.data || []).map((item) =>
                normalizeMembershipEntity(item, "report", memberships))
        }catch (e){
            throw e;
        } finally {
            setLoading(false);
        }
    }

    const updateReport = async (reportId, reportData)=>{
        if (!reportId) return;
        setLoading(true);
        try {
            const report = new Report();
            const payload = prepareMembershipPayload("report", reportData, memberships, {
                currentMembership: workspaceMembershipData,
                operation: "update",
            });
            const _data = await report.update(reportId, payload, {populate: reportPopulate});
            return normalizeMembershipEntity(_data.data, "report", memberships)
        }catch (e){
            throw e;
        } finally {
            setLoading(false);
        }
    }

    const createReport = async (reportData)=>{
        setLoading(true);
        try {
            const report = new Report();
            const payload = prepareMembershipPayload("report", reportData, memberships, {
                currentMembership: workspaceMembershipData,
                operation: "create",
            });
            const _data = await report.create(payload, {populate: reportPopulate});
            return normalizeMembershipEntity(_data.data, "report", memberships)
        }catch (e){
            throw e;
        } finally {
            setLoading(false);
        }
    }

    const normalizeReport=(reportData, result)=>{
        let render;
        let _measure = reportData.measure;
        let _dimension = reportData.dimension;

        if (_measure&&_dimension){
            if (reportData.populatedDimension){
                const groups = groupBy(result, (item) => item[_dimension]?.documentId);
                switch (_measure) {
                    case "count":render = Object.entries(groups).map(([groupByDocumentId, values]) => ({
                        dimension:values?.[0][_dimension],
                        total: values.length
                    }));
                        break;
                    default:
                        break;
                }
            }
            else{
                const groups = groupBy(result, _dimension);

                switch (_measure) {
                    case "count":render = Object.entries(groups).map(([_dimension, values]) => ({
                        dimension:_dimension,
                        total: values.length
                    }));
                        break;
                    default:
                        break;
                }
            }
        }
        // console.log(render)
        return {...reportData, render}

    }

    const fetchReport = async (reportData)=>{//reportData?.filters||{}
        let query = {
            filters: {
                $and: [
                    {workspace: {$eq: workspaceMembershipData?.workspace.id}}, ...reportData?.filters?.["$and"]||[]
                ],
                $or:reportData?.filters?.["$or"]||[]
            }
        }
        if (reportData.populatedDimension){
            query = {...query, populate:[reportData.dimension]}
        }
        return await model[reportData?.dataSource].getAll(query);
    }


    return {loading, getReports, updateReport, createReport, normalizeReport, fetchReport};
}
